import React from 'react'
import { PasswordRenewComplete } from '../../../components/templates'
import { Meta } from '../../../Meta'

export const UserPasswordRenewComplete: React.FC = () => {
  return (
    <>
      <Meta title="パスワード再設定完了" />
      <PasswordRenewComplete />
    </>
  )
}
